import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTheme } from '../ThemeContext';
import axios from 'axios';
import GenerationReel from '../components/GenerationReel';

const API = process.env.REACT_APP_BACKEND_URL;

const generations = [
  {
    id: 'greatest', label: 'Greatest Generation', years: '1901 — 1927', color: '#D4AF37', icon: 'G',
    nostalgia: [
      { img: 'https://images.unsplash.com/photo-1767436620079-c423be9f9a69?w=600', caption: 'La macchina da scrivere — l\'unico modo per comunicare' },
      { img: 'https://images.unsplash.com/photo-1639148604826-8c8afc2aefe5?w=600', caption: 'La radio a valvole — le notizie dal fronte' },
      { img: 'https://images.pexels.com/photos/15538178/pexels-photo-15538178.jpeg?auto=compress&cs=tinysrgb&w=600', caption: 'Soldati al fronte — la Grande Guerra' },
      { img: 'https://images.unsplash.com/photo-1760766144822-0c35be064038?w=600', caption: 'Il telefono a rotella — lusso per pochi' },
      { img: 'https://images.unsplash.com/photo-1693688236018-5d560eb87a3b?w=600', caption: 'Radio d\'epoca — la voce del mondo entrava in casa' },
      { img: 'https://images.pexels.com/photos/6979928/pexels-photo-6979928.jpeg?auto=compress&cs=tinysrgb&w=600', caption: 'Macchina da scrivere e libri — il sapere analogico' },
      { img: 'https://images.unsplash.com/photo-1690061522136-75e3fc60873a?w=600', caption: 'Tamburi militari — il suono della storia' },
    ],
    panels: [
      { type: 'narration', text: 'Nati in un mondo senza elettricità in molte case italiane. Hanno visto l\'Italia passare dalla monarchia alla repubblica.' },
      { type: 'speech', speaker: 'Un nonno del \'22', text: 'A 18 anni ero in trincea. A 20 ricostruivo la casa con le mie mani. Non avevamo niente, ma avevamo la dignità.' },
      { type: 'event', text: '1915-18: Prima Guerra Mondiale · 1922: Marcia su Roma · 1940-45: Seconda Guerra Mondiale · 1946: Nasce la Repubblica Italiana' },
      { type: 'speech', speaker: 'Una nonna del \'25', text: 'Il pane lo facevamo noi. I vestiti li cucivamo noi. I figli li crescevamo nel campo. E non ci siamo mai lamentati.' },
      { type: 'narration', text: 'Senza di loro, non esisteremmo. Punto. Ogni diritto che abbiamo oggi è stato pagato col loro sudore e il loro sangue.' },
    ]
  },
  {
    id: 'silent', label: 'Silent Generation', years: '1928 — 1945', color: '#94A3B8', icon: 'S',
    nostalgia: [
      { img: 'https://images.unsplash.com/photo-1640804754609-41bc57251943?w=600', caption: 'La prima televisione RAI — il mondo entra in casa' },
      { img: 'https://images.unsplash.com/photo-1697466245863-7a740383408d?w=600', caption: 'La Vespa — simbolo del miracolo economico' },
      { img: 'https://images.pexels.com/photos/36505468/pexels-photo-36505468.jpeg?auto=compress&cs=tinysrgb&w=600', caption: 'FIAT 500 rossa — l\'Italia che corre' },
      { img: 'https://images.unsplash.com/photo-1602577745097-46918d598681?w=600', caption: 'FIAT 500 bianca — il sogno di ogni famiglia' },
      { img: 'https://images.unsplash.com/photo-1702320506848-115b77739849?w=600', caption: 'Vespa parcheggiata — la dolce vita' },
      { img: 'https://images.unsplash.com/photo-1664286244224-a167467f05c2?w=600', caption: 'Vespa verde — design italiano iconico' },
      { img: 'https://images.unsplash.com/photo-1693924585959-f8200be440ae?w=600', caption: 'Utilitaria vintage — la motorizzazione di massa' },
    ],
    panels: [
      { type: 'narration', text: 'Cresciuti tra le bombe e la fame. Da bambini hanno conosciuto le tessere annonarie, i rifugi antiaerei, lo sfollamento nelle campagne.' },
      { type: 'speech', speaker: 'Un professore del \'35', text: 'Ci chiamano "silenziosi" perché abbiamo imparato che parlare troppo poteva costare caro. Ma in silenzio abbiamo costruito il miracolo economico.' },
      { type: 'event', text: '1946: Voto alle donne · 1948: Costituzione Italiana · 1950-60: Miracolo Economico · 1954: La RAI trasmette per la prima volta' },
      { type: 'speech', speaker: 'Una sarta del \'40', text: 'La prima volta che ho visto la televisione ho pianto. Dopo anni di buio, vedevamo il mondo da casa nostra.' },
      { type: 'narration', text: 'Hanno costruito le fondamenta su cui camminiamo. Le scuole, gli ospedali, le fabbriche. Tutto quello che diamo per scontato.' },
    ]
  },
  {
    id: 'boomer', label: 'Baby Boomer', years: '1946 — 1964', color: '#EF4444', icon: 'BB',
    nostalgia: [
      { img: 'https://images.unsplash.com/photo-1748239994589-95ec583d9e8f?w=600', caption: 'I Beatles sul giradischi — la rivoluzione musicale' },
      { img: 'https://images.unsplash.com/photo-1603850121303-d4ade9e5ba65?w=600', caption: 'Vinile e puntina — il suono caldo analogico' },
      { img: 'https://images.unsplash.com/photo-1551197359-a0ddb39e6d1e?w=600', caption: 'Disco in vinile — colonna sonora di una generazione' },
      { img: 'https://images.unsplash.com/photo-1570910493231-e2679e2ef62c?w=600', caption: 'Proteste studentesche — il \'68 in piazza' },
      { img: 'https://images.unsplash.com/photo-1772562895004-745222b78376?w=600', caption: 'Walkman rosso — la musica diventa portatile' },
      { img: 'https://images.unsplash.com/photo-1677519419110-6489339d5db4?w=600', caption: 'Giradischi in legno — il salotto di casa' },
      { img: 'https://images.pexels.com/photos/9245734/pexels-photo-9245734.jpeg?auto=compress&cs=tinysrgb&w=600', caption: 'Cassette e VHS — il nostro archivio di ricordi' },
    ],
    panels: [
      { type: 'narration', text: 'I figli del dopoguerra. Nati nel periodo di maggiore crescita demografica della storia. L\'Italia era in piena ricostruzione.' },
      { type: 'speech', speaker: 'Un imprenditore del \'52', text: 'I miei genitori non avevano nulla. Io ho avuto la Vespa, la TV a colori e la possibilità di studiare. Ma me la sono sudata.' },
      { type: 'event', text: '1968: Contestazione studentesca · 1970: Statuto dei lavoratori · 1974: Referendum divorzio · 1978: Rapimento Moro' },
      { type: 'speech', speaker: 'Una insegnante del \'58', text: 'Noi scendevamo in piazza. Noi occupavamo le università. Credevamo di poter cambiare il mondo. E in parte l\'abbiamo fatto.' },
      { type: 'narration', text: 'Hanno creato il welfare italiano, le pensioni, la sanità pubblica. Il Made in Italy è diventato un brand globale grazie a loro.' },
    ]
  },
  {
    id: 'boomers', label: 'Boomer', years: 'Stato mentale', color: '#FF6347', icon: 'OK',
    nostalgia: [],
    panels: [
      { type: 'narration', text: '"OK Boomer." Un termine che è diventato un meme globale. Ma chi sono davvero i Boomer nel linguaggio di oggi?' },
      { type: 'speech', speaker: 'Gen Z su TikTok', text: 'Boomer non è un\'età. È quando mandi i vocali di 4 minuti, scrivi in MAIUSCOLO su WhatsApp e pensi che il WiFi sia una persona.' },
      { type: 'event', text: '2019: "OK Boomer" diventa virale · Usato al Parlamento neozelandese · Spotify crea playlist "OK Boomer"' },
      { type: 'speech', speaker: 'Un Baby Boomer vero', text: 'Mi chiamano Boomer perché uso ancora la rubrica di carta. Ma almeno io so fare la carbonara senza guardare YouTube.' },
      { type: 'narration', text: 'Al Digital Hub, i "Boomer" non sono il problema — sono la risorsa. La loro esperienza analogica combinata con il digitale crea magia.' },
    ]
  },
  {
    id: 'x', label: 'Generazione X', years: '1965 — 1980', color: '#FFD700', icon: 'X',
    nostalgia: [
      { img: 'https://images.pexels.com/photos/9140593/pexels-photo-9140593.jpeg?auto=compress&cs=tinysrgb&w=600', caption: 'Commodore 64 — il primo amore digitale' },
      { img: 'https://images.unsplash.com/photo-1627664220128-ff2232937726?w=600', caption: 'Game Boy — ore intere a giocare a Tetris' },
      { img: 'https://images.unsplash.com/photo-1631896928992-90e5a2cc7a4e?w=600', caption: 'Game Boy Color — il gaming diventa portatile' },
      { img: 'https://images.unsplash.com/photo-1577807542494-e589e3cf3438?w=600', caption: 'Muro di Berlino — il giorno in cui il mondo cambiò' },
      { img: 'https://images.pexels.com/photos/9977053/pexels-photo-9977053.jpeg?auto=compress&cs=tinysrgb&w=600', caption: 'East Side Gallery — il bacio che fece la storia' },
      { img: 'https://images.pexels.com/photos/10126380/pexels-photo-10126380.jpeg?auto=compress&cs=tinysrgb&w=600', caption: 'Sala giochi arcade — le monetine del pomeriggio' },
      { img: 'https://images.unsplash.com/photo-1611001716885-b3402558a62b?w=600', caption: 'Walkman Sony — la musica camminava con noi' },
    ],
    panels: [
      { type: 'narration', text: 'La generazione dimenticata. Schiacciati tra i Boomer rumorosi e i Millennials protagonisti. Ma sono il collante silenzioso.' },
      { type: 'speech', speaker: 'Un informatico del \'72', text: 'Il mio primo computer era un Commodore 64. Scrivevo codice su cassette. Oggi gestisco server cloud.' },
      { type: 'event', text: '1989: Caduta Muro di Berlino · 1992: Tangentopoli · 1994: World Wide Web in Italia · 2001: Torri Gemelle' },
      { type: 'speech', speaker: 'Una manager del \'68', text: 'Noi non piangiamo sui social. Ci rimbocchiamo le maniche e risolviamo. È nel nostro DNA.' },
      { type: 'narration', text: 'Pragmatici, indipendenti, adattabili. Sono i genitori dei Gen Z e Alpha. Il ponte perfetto tra analogico e digitale.' },
    ]
  },
  {
    id: 'millennials', label: 'Millennials', years: '1981 — 1996', color: '#FF6B35', icon: 'M',
    nostalgia: [
      { img: 'https://images.pexels.com/photos/9245734/pexels-photo-9245734.jpeg?auto=compress&cs=tinysrgb&w=600', caption: 'VHS e cassette — il nostro Netflix era il videonoleggio' },
      { img: 'https://images.pexels.com/photos/28077392/pexels-photo-28077392.jpeg?auto=compress&cs=tinysrgb&w=600', caption: 'Floppy disk e Walkman — la tecnologia degli anni \'90' },
      { img: 'https://images.unsplash.com/photo-1643654314956-3a1f360f0149?w=600', caption: 'Il primo iPhone — il giorno in cui tutto è cambiato' },
      { img: 'https://images.pexels.com/photos/8720273/pexels-photo-8720273.jpeg?auto=compress&cs=tinysrgb&w=600', caption: 'Laptop, CD, floppy — la scrivania del 2001' },
      { img: 'https://images.unsplash.com/photo-1684402362866-b8e5983b5b49?w=600', caption: 'Sony Walkman Sport — musica sotto la pioggia' },
      { img: 'https://images.pexels.com/photos/5426409/pexels-photo-5426409.jpeg?auto=compress&cs=tinysrgb&w=600', caption: 'Le app sullo smartphone — da MSN a Instagram' },
      { img: 'https://images.unsplash.com/photo-1609603078807-cf61d4f77e94?w=600', caption: 'Controller Nintendo — le maratone gaming del weekend' },
    ],
    panels: [
      { type: 'narration', text: 'La prima generazione a crescere con internet. Dal 56k al 5G. Dal VHS a Netflix. Dal floppy disk al cloud.' },
      { type: 'speech', speaker: 'Una startup founder dell\'88', text: 'Ho imparato a programmare su MSN Messenger. Il mio primo business l\'ho lanciato da un bar con il WiFi gratis.' },
      { type: 'event', text: 'ISDN → ADSL → Fibra · 2004: Facebook · 2007: iPhone · 2008: Crisi · 2020: Pandemia e smart working' },
      { type: 'speech', speaker: 'Un freelancer del \'92', text: 'Ci dicevano che con la laurea avremmo avuto tutto. Invece abbiamo avuto stage gratis. Ma ci siamo reinventati.' },
      { type: 'narration', text: 'VHS → DVD → Streaming. ISDN → ADSL → Fibra → AI. Nessuna generazione ha attraversato tante rivoluzioni tecnologiche in così poco tempo.' },
    ]
  },
  {
    id: 'z', label: 'Generazione Z', years: '1997 — 2012', color: '#A855F7', icon: 'Z',
    nostalgia: [
      { img: 'https://images.unsplash.com/photo-1665327465053-3b85fe6578d8?w=600', caption: 'Content creator — la camera è sempre accesa' },
      { img: 'https://images.pexels.com/photos/6593719/pexels-photo-6593719.jpeg?auto=compress&cs=tinysrgb&w=600', caption: 'Ring light e smartphone — lo studio è ovunque' },
      { img: 'https://images.pexels.com/photos/7481973/pexels-photo-7481973.jpeg?auto=compress&cs=tinysrgb&w=600', caption: 'Vlogging quotidiano — la vita diventa contenuto' },
      { img: 'https://images.unsplash.com/photo-1617349035633-952a8907bdb0?w=600', caption: 'Creator professionista — business dalla cameretta' },
      { img: 'https://images.unsplash.com/photo-1617349035560-b32339aeeb14?w=600', caption: 'Behind the scenes — il dietro le quinte del content' },
      { img: 'https://images.unsplash.com/photo-1665327469486-c1d47eed44ae?w=600', caption: 'Emozioni in camera — l\'autenticità prima di tutto' },
      { img: 'https://images.unsplash.com/photo-1611087889903-b4837b46857c?w=600', caption: 'Lo smartphone sempre in mano — il mondo nel palmo' },
    ],
    panels: [
      { type: 'narration', text: 'I veri nativi digitali. Non hanno mai conosciuto un mondo senza internet. Lo smartphone è un\'estensione del loro corpo.' },
      { type: 'speech', speaker: 'Una creator del 2003', text: 'Ho 22 anni e guadagno più dei miei genitori facendo video. Non è fortuna — è capire il linguaggio del futuro.' },
      { type: 'event', text: '2016: TikTok · 2019: Fridays for Future · 2020: Lockdown e DAD · 2022: ChatGPT · 2024: AI ovunque' },
      { type: 'speech', speaker: 'Uno studente del 2005', text: 'I Boomer ci dicono di alzarci dal divano. Ma noi dal divano abbiamo creato movimenti globali e startup.' },
      { type: 'narration', text: 'Sono i mentori naturali della Gen Alpha. Parlano il loro linguaggio ma hanno abbastanza esperienza per guidarli.' },
    ]
  },
  {
    id: 'alpha', label: 'Gen Alpha', years: '2013 — 2024', color: '#00FF41', icon: 'A',
    nostalgia: [
      { img: 'https://images.unsplash.com/photo-1758612897668-ce0c153745e4?w=600', caption: 'Tablet a 3 anni — per loro è naturale come respirare' },
      { img: 'https://images.unsplash.com/photo-1767955006100-cf73d990599f?w=600', caption: 'Un bambino e il suo robot — amicizia 2.0' },
      { img: 'https://images.pexels.com/photos/35280153/pexels-photo-35280153.jpeg?auto=compress&cs=tinysrgb&w=600', caption: 'Robot umanoide — il futuro è già qui' },
      { img: 'https://images.pexels.com/photos/18799044/pexels-photo-18799044.jpeg?auto=compress&cs=tinysrgb&w=600', caption: 'AI con occhi LED — la tecnologia ha un volto' },
      { img: 'https://images.unsplash.com/photo-1768400730812-039f5971185d?w=600', caption: 'Robot compagni — AI che giocano con te' },
      { img: 'https://images.unsplash.com/photo-1767716134895-296cbd7aec1a?w=600', caption: 'Robot giallo — il pet digitale del futuro' },
      { img: 'https://images.unsplash.com/photo-1768400730810-5c4398d58ae7?w=600', caption: 'Robot arancione — ogni bambino ne avrà uno' },
    ],
    panels: [
      { type: 'narration', text: 'I bambini dell\'AI. Per loro, parlare con un\'intelligenza artificiale è naturale come respirare.' },
      { type: 'speech', speaker: 'Un bambino del 2015', text: 'Perché devo scrivere se posso parlare con il telefono? E perché la TV non mi risponde quando le parlo?' },
      { type: 'event', text: '2013: iPad Mini · 2016: Alexa in Italia · 2020: Pandemia e didattica digitale · 2023: AI generativa mainstream' },
      { type: 'speech', speaker: 'Una ragazzina del 2013', text: 'Da grande voglio fare la programmatrice. O la youtuber. O tutte e due. Perché devo scegliere?' },
      { type: 'narration', text: 'Sono il cuore del progetto AI_COVO. Nel team Fortnite-style, la Gen Alpha porta la creatività pura, senza filtri.' },
    ]
  },
  {
    id: 'beta', label: 'Gen Beta', years: '2025 — oggi', color: '#00DDFF', icon: 'B',
    nostalgia: [
      { img: 'https://images.unsplash.com/photo-1495461412280-56774253ada7?w=600', caption: 'La manina del neonato — il futuro in un pugno' },
      { img: 'https://images.unsplash.com/photo-1560306580-9e204fe45f3e?w=600', caption: 'Incubatrice hi-tech — la tecnologia li accoglie dal primo giorno' },
      { img: 'https://images.unsplash.com/photo-1560307815-52379f7efa8a?w=600', caption: 'Tra le braccia — il calore umano non cambia mai' },
      { img: 'https://images.pexels.com/photos/33508363/pexels-photo-33508363.jpeg?auto=compress&cs=tinysrgb&w=600', caption: 'Primo biberon — si comincia da qui' },
      { img: 'https://images.pexels.com/photos/29352344/pexels-photo-29352344.jpeg?auto=compress&cs=tinysrgb&w=600', caption: 'Fototerapia neonatale — la scienza li protegge' },
      { img: 'https://images.unsplash.com/photo-1767955006100-cf73d990599f?w=600', caption: 'Il robot che li aspetta — quando cresceranno, sarà il loro mondo' },
      { img: 'https://images.pexels.com/photos/35280153/pexels-photo-35280153.jpeg?auto=compress&cs=tinysrgb&w=600', caption: 'AI umanoide — il compagno di classe del 2035' },
    ],
    panels: [
      { type: 'narration', text: 'Appena nati. Il mondo che li accoglie è già completamente diverso da tutto.' },
      { type: 'speech', speaker: 'Anno 2025', text: 'Benvenuto al mondo. L\'AI è già qui. Ma non preoccuparti — hai 8 generazioni alle spalle che ti proteggono.' },
      { type: 'event', text: '2025: Prima generazione nata nell\'era dell\'AI generativa · Il futuro è tutto da scrivere' },
      { type: 'narration', text: 'Il Digital Hub esiste anche per loro. Quando avranno 10 anni, troveranno un ecosistema pronto — costruito da tutti, insieme.' },
    ]
  },
];

const categories = {
  ceramica: { label: 'Ceramica', color: '#D4AF37' },
  paglia: { label: 'Cappelli in Paglia', color: '#FFD700' },
  cucina: { label: 'Ricette Antiche', color: '#EF4444' },
  orto: { label: 'Orto Condiviso', color: '#00FF41' },
};

const ComicPanel = ({ panel, color, isInstitutional }) => {
  if (panel.type === 'narration') {
    return (
      <div className={`p-5 rounded-lg border-l-4 ${isInstitutional ? 'bg-[#F5F0E8]' : 'bg-zinc-900/80'}`} style={{ borderLeftColor: color }}>
        <p className={`text-sm md:text-base leading-relaxed italic ${isInstitutional ? 'text-[#3A3020]' : 'text-zinc-300'}`}>{panel.text}</p>
      </div>
    );
  }
  if (panel.type === 'speech') {
    return (
      <div className="relative">
        <div className={`relative p-5 rounded-2xl ${isInstitutional ? 'bg-white border-2 border-[#E2DED6]' : 'bg-[#111] border-2 border-zinc-700'}`} style={{ borderColor: `${color}44` }}>
          <p className={`text-sm md:text-base leading-relaxed font-medium ${isInstitutional ? 'text-[#1B2A4A]' : 'text-white'}`}>"{panel.text}"</p>
          <div className="absolute -bottom-2 left-8 w-4 h-4 rotate-45" style={{ background: isInstitutional ? '#fff' : '#111', borderRight: `2px solid ${color}44`, borderBottom: `2px solid ${color}44` }} />
        </div>
        <p className="mt-3 ml-4 text-xs font-black uppercase tracking-wider" style={{ color }}>— {panel.speaker}</p>
      </div>
    );
  }
  if (panel.type === 'event') {
    return (
      <div className={`p-4 rounded-xl text-center ${isInstitutional ? 'bg-[#1B2A4A]/5' : 'bg-zinc-800/50'}`}>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] mb-1" style={{ color }}>Timeline</p>
        <p className={`text-xs md:text-sm font-mono leading-relaxed ${isInstitutional ? 'text-[#5A6B80]' : 'text-zinc-400'}`}>{panel.text}</p>
      </div>
    );
  }
  return null;
};

const NostalgiaStrip = ({ images, color }) => {
  if (!images || images.length === 0) return null;
  return (
    <div className="flex gap-4 overflow-x-auto pb-2 my-4 snap-x">
      {images.map((img, i) => (
        <div key={i} className="flex-shrink-0 snap-center w-56 md:w-72 rounded-xl overflow-hidden border-2" style={{ borderColor: `${color}33` }}>
          <img src={img.img} alt={img.caption} className="w-full h-36 md:h-44 object-cover" loading="lazy" />
          <p className="px-3 py-2 text-[10px] md:text-xs font-mono text-zinc-400 bg-black/60 backdrop-blur">{img.caption}</p>
        </div>
      ))}
    </div>
  );
};

const StoneButton = ({ type, onClick, count, voted }) => {
  const isWhite = type === 'white';
  return (
    <button onClick={onClick} data-testid={`stone-${type}`}
      className={`flex flex-col items-center gap-1 px-4 py-3 rounded-xl border-2 transition-all ${voted === type ? 'scale-110' : 'hover:scale-105'}`}
      style={{
        borderColor: voted === type ? (isWhite ? '#fff' : '#666') : '#333',
        background: voted === type ? (isWhite ? 'rgba(255,255,255,0.1)' : 'rgba(100,100,100,0.1)') : 'transparent',
      }}>
      <div className={`w-10 h-10 rounded-full flex items-center justify-center border-2 ${isWhite ? 'bg-white border-white' : 'bg-zinc-800 border-zinc-600'}`}>
        {!isWhite && <div className="w-3 h-3 rounded-full bg-black" />}
      </div>
      <span className="text-[10px] font-bold text-zinc-400">{isWhite ? 'CI SARÒ' : 'PASSO'}</span>
      {count > 0 && <span className="text-[9px] text-zinc-600">{count}</span>}
    </button>
  );
};

const GenerazioniPage = () => {
  const { isInstitutional } = useTheme();
  const location = useLocation();
  const [events, setEvents] = useState([]);
  const [votes, setVotes] = useState({});

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.slice(1));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 300);
    }
  }, [location.hash]);

  useEffect(() => {
    axios.post(`${API}/api/agora/seed`).catch(() => {});
    axios.get(`${API}/api/agora/events`).then(r => setEvents(r.data)).catch(() => {});
  }, []);

  const handleVote = async (eventId, stone, genLabel) => {
    try {
      await axios.post(`${API}/api/agora/vote`, { event_id: eventId, stone, generation: genLabel || 'Visitatore' });
      setVotes(v => ({ ...v, [eventId]: stone }));
      const r = await axios.get(`${API}/api/agora/events`);
      setEvents(r.data);
    } catch {}
  };

  return (
    <main className={`min-h-screen pt-28 pb-24 px-4 ${isInstitutional ? 'bg-[#FAF9F6]' : 'bg-[#050505]'}`}>
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <p className="font-mono text-5xl md:text-7xl font-black text-[#00FF41] mb-1" style={{ textShadow: '0 0 30px rgba(0,255,65,0.3)', letterSpacing: '8px' }}>&lt; /</p>
          <p className="font-mono text-[10px] md:text-xs font-black uppercase tracking-[0.3em] text-zinc-400 mb-4">DIGITAL HUB SOCIALE</p>
          <p className={`font-mono text-xs uppercase tracking-[0.3em] mb-4 ${isInstitutional ? 'text-[#C4532D]' : 'text-[#00FF41]'}`}>Cross-Generazionale</p>
          <h1 className={`text-4xl sm:text-5xl lg:text-6xl font-black mb-4 ${isInstitutional ? 'text-[#1B2A4A]' : 'text-white'}`}
            style={{ fontFamily: isInstitutional ? "'Source Serif 4', serif" : "'JetBrains Mono', monospace" }}>
            Le Generazioni
          </h1>
          <p className={`text-base max-w-2xl mx-auto mb-6 ${isInstitutional ? 'text-[#5A6B80]' : 'text-zinc-400'}`}>
            Ogni generazione ha attraversato il proprio inferno e costruito il proprio paradiso. Questa è la loro storia — raccontata come un fumetto.
          </p>
          <p className="text-zinc-500 text-xs italic">"io voglio sapere per fare, io voglio fare per sapere."</p>
        </div>

        {/* Generations */}
        <div className="space-y-24">
          {generations.map((gen) => (
            <section key={gen.id} id={gen.id} data-testid={`gen-section-${gen.id}`} className="scroll-mt-28">
              <div className="flex items-center gap-4 mb-8">
                <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl flex items-center justify-center text-xl md:text-2xl font-black flex-shrink-0"
                  style={{ background: `${gen.color}15`, color: gen.color, border: `2px solid ${gen.color}33`, fontFamily: "'JetBrains Mono', monospace", boxShadow: `0 0 30px ${gen.color}15` }}>
                  {gen.icon}
                </div>
                <div className="flex-1">
                  <h2 className={`text-2xl md:text-3xl font-black ${isInstitutional ? 'text-[#1B2A4A]' : 'text-white'}`}>{gen.label}</h2>
                  <div className="flex items-center gap-3 mt-2">
                    <span className="font-mono text-lg md:text-xl font-black tracking-wide" style={{ color: gen.color, textShadow: `0 0 15px ${gen.color}33` }}>{gen.years}</span>
                  </div>
                </div>
              </div>
              {/* Nostalgia strip */}
              <NostalgiaStrip images={gen.nostalgia} color={gen.color} />
              {/* Video Reel Sora 2 — tutte le generazioni reali */}
              {['greatest','silent','boomer','x','millennials','z','alpha','beta'].includes(gen.id) && (
                <div className="my-6 max-w-2xl mx-auto">
                  <GenerationReel generation={gen.id} />
                </div>
              )}
              {/* Comic panels */}
              <div className="space-y-5 ml-4 md:ml-10 relative">
                <div className="absolute left-0 top-0 bottom-0 w-px opacity-20" style={{ background: gen.color }} />
                {gen.panels.map((panel, i) => (
                  <div key={i} className="relative pl-6">
                    <div className="absolute left-0 top-3 w-2 h-2 rounded-full" style={{ background: gen.color, transform: 'translateX(-50%)' }} />
                    <ComicPanel panel={panel} color={gen.color} isInstitutional={isInstitutional} />
                  </div>
                ))}
              </div>
              <div className="mt-12 flex items-center gap-4">
                <div className="flex-1 h-px" style={{ background: `${gen.color}20` }} />
                <div className="w-2 h-2 rounded-full" style={{ background: gen.color, opacity: 0.3 }} />
                <div className="flex-1 h-px" style={{ background: `${gen.color}20` }} />
              </div>
            </section>
          ))}
        </div>

        {/* ═══════ AGORÀ — Piazza Cross-Generazionale ═══════ */}
        <section id="agora" data-testid="agora-section" className="mt-32 scroll-mt-28">
          <div className="text-center mb-16">
            <p className="font-mono text-5xl font-black text-[#D4AF37] mb-4" style={{ textShadow: '0 0 20px rgba(212,175,55,0.3)' }}>AGORA'</p>
            <h2 className={`text-3xl md:text-4xl font-black mb-3 ${isInstitutional ? 'text-[#1B2A4A]' : 'text-white'}`}>
              La Piazza dell'Artigianato
            </h2>
            <p className={`text-sm max-w-xl mx-auto mb-3 ${isInstitutional ? 'text-[#5A6B80]' : 'text-zinc-400'}`}>
              Le generazioni non si incontrano 1 a 1. Si incontrano nella piazza — l'Agorà.
              Senatori e ragazzi, insieme, creano ARTIGIANATO nel Castello di Colle Alta.
            </p>
            <p className={`text-xs max-w-lg mx-auto ${isInstitutional ? 'text-[#5A6B80]' : 'text-zinc-500'}`}>
              Nell'antica Grecia i cittadini votavano con i <em>psephoi</em>: sasso bianco per il sì, sasso nero per il no. Qui funziona allo stesso modo.
            </p>
          </div>

          {/* Category pills */}
          <div className="flex flex-wrap gap-2 justify-center mb-10">
            {Object.entries(categories).map(([k, v]) => (
              <span key={k} className="text-[10px] font-mono uppercase tracking-wider px-3 py-1.5 rounded-full border" style={{ borderColor: `${v.color}33`, color: v.color }}>
                {v.label}
              </span>
            ))}
          </div>

          {/* Artisan image */}
          <div className="flex justify-center mb-10">
            <div className="w-full max-w-lg rounded-2xl overflow-hidden border border-zinc-700">
              <img src="https://images.pexels.com/photos/18373966/pexels-photo-18373966.jpeg?auto=compress&cs=tinysrgb&w=800" alt="Artigianato tradizionale" className="w-full h-48 md:h-56 object-cover" loading="lazy" />
              <p className="bg-black/80 backdrop-blur px-4 py-2 text-xs text-zinc-400 font-mono text-center">Castello di Colle Alta — dove le generazioni creano insieme</p>
            </div>
          </div>

          {/* Events */}
          <div className="space-y-6">
            {events.map(ev => {
              const cat = categories[ev.category] || { label: ev.category, color: '#aaa' };
              return (
                <div key={ev.id} data-testid={`agora-event-${ev.id}`}
                  className={`rounded-2xl overflow-hidden border ${isInstitutional ? 'bg-white border-[#E2DED6]' : 'bg-[#0A0A0A] border-zinc-800'}`}>
                  <div className="p-6">
                    <div className="flex items-start justify-between gap-4 mb-3">
                      <div>
                        <span className="text-[10px] font-mono uppercase tracking-wider px-2 py-0.5 rounded-full inline-block mb-2" style={{ background: `${cat.color}15`, color: cat.color }}>{cat.label}</span>
                        <h3 className={`text-lg md:text-xl font-black ${isInstitutional ? 'text-[#1B2A4A]' : 'text-white'}`}>{ev.title}</h3>
                      </div>
                      {ev.event_date && (
                        <span className="text-[10px] font-mono text-zinc-500 whitespace-nowrap">{new Date(ev.event_date).toLocaleDateString('it-IT', { day: 'numeric', month: 'short' })}</span>
                      )}
                    </div>
                    <p className={`text-sm mb-4 ${isInstitutional ? 'text-[#5A6B80]' : 'text-zinc-400'}`}>{ev.description}</p>
                    {ev.location && <p className="text-[10px] font-mono text-zinc-600 mb-4">{ev.location}</p>}

                    {/* Voting */}
                    <div className="flex items-center gap-6 justify-center">
                      <StoneButton type="white" count={ev.white_count} voted={votes[ev.id]} onClick={() => handleVote(ev.id, 'white')} />
                      <span className={`text-xs ${isInstitutional ? 'text-[#5A6B80]' : 'text-zinc-600'}`}>o</span>
                      <StoneButton type="black" count={ev.black_count} voted={votes[ev.id]} onClick={() => handleVote(ev.id, 'black')} />
                    </div>

                    {/* Participants */}
                    {ev.white_count > 0 && (
                      <p className="text-center text-[10px] text-zinc-600 mt-3 font-mono">{ev.white_count} {ev.white_count === 1 ? 'persona' : 'persone'} ci {ev.white_count === 1 ? 'sarà' : 'saranno'}</p>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Closing */}
          <div className={`text-center mt-16 p-10 rounded-2xl ${isInstitutional ? 'bg-[#C4532D]/5 border border-[#C4532D]/20' : 'bg-[#00FF41]/5 border border-[#00FF41]/20'}`}>
            <p className="font-mono text-xs text-[#D4AF37] uppercase tracking-widest mb-3">Castello di Colle Alta</p>
            <p className={`text-xl md:text-2xl font-black mb-3 ${isInstitutional ? 'text-[#1B2A4A]' : 'text-white'}`}>
              9 generazioni. 1 piazza. Artigianato.
            </p>
            <p className={`text-sm max-w-xl mx-auto ${isInstitutional ? 'text-[#5A6B80]' : 'text-zinc-400'}`}>
              Cappelli in paglia, ceramica, ricette antiche, orto condiviso — i nonni insegnano, i nipoti creano. Espongono insieme al Castello. Nessuna generazione esclusa.
            </p>
          </div>
        </section>
      </div>
    </main>
  );
};

export default GenerazioniPage;
